import axios from '@/api/http';
import base from '@/api//base';
const target = {
	// 分页请求所有数据-目标
	TargetPage(params){
		return axios.post(`${base.baseURL}/Target/page`,params);
	},
	// 新增数据-目标
	TargetInsert(params){
		return axios.post(`${base.baseURL}/Target/insert`,params);
	},
	// 修改数据-目标
	TargetUpdate(params){
		return axios.post(`${base.baseURL}/Target/update`,params);
	},
	// 删除数据-目标
	TargetDeleteById(id){
		return axios.post(`${base.baseURL}/Target/delete/${id}`);
	},
	// 结束目标-目标
	TargetRealizeById(id){
		return axios.get(`${base.baseURL}/Target/realize/${id}`);
	},
}
export default target;



// WEBPACK FOOTER //
// ./src/network/target.js